import gql from 'graphql-tag'

export const STAFF_FORGOT_PASSWORD = gql`
  mutation STAFF_FORGOT_PASSWORD($email: String!) {
    staffResetPassword(email: $email)
  }
`
